<template>
    <v-card>
        <v-toolbar color="primary" flat dark>
            <v-toolbar-title>
                {{ trans('permissions.title') }}
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <h3 class="mt-4">{{ trans('permissions.description') }}</h3>
            <v-switch
                v-for="(permission,i) in list" :key="i" 
                :label="trans('permissions.fields.' + i)" 
                v-bind="{ loading, disabled }"
                v-model="list[i]"  
                small
            >
            </v-switch>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="white" @click="$emit('close')">
                <v-icon left>close</v-icon>
                Chiudi
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'resource-permissions',
    props: {
        permissions: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        let list = this.permissions;

        return {
            list,
        }
    },
}
</script>